import { Space, Tag } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
    ButtonItem,
    ModalItem,
    TableItem,
} from "../../../../Components/Items";

class ModalListaEtapa extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
        lotes: []
    };

    cerrarListaEtapa() {
        this.props.cerrarListaEtapa();
    }

    moverLoteEtapa(loteId, nuevaEtapaId) {
        this.props.moverLoteEtapa(loteId, nuevaEtapaId);
    }

    render() {

        const columns = [
            {
                title: "Numero",
                dataIndex: "numero",
                key: "numero",
                sorter: (a, b) => a.numero - b.numero,
                buscar: "numero",
                width: "10%",
            },
            {
                title: "Nombre",
                dataIndex: "insumoNombre",
                key: "insumoNombre",
                sorter: (a, b) => a.insumoNombre.localeCompare(b.insumoNombre),
                buscar: "insumoNombre",
                width: "20%",
            },
            // {
            //     title: "Descripción",
            //     dataIndex: "descripcion",
            //     key: "descripcion",
            //     sorter: (a, b) => a.descripcion.localeCompare(b.descripcion),
            //     buscar: "descripcion",
            // },
            {
                title: "Cliente",
                dataIndex: "clienteNombre",
                key: "clienteNombre",
                sorter: (a, b) => a.clienteNombre.localeCompare(b.clienteNombre),
                buscar: "clienteNombre",
                width: "20%",
            },
            {
                title: "Estado",
                dataIndex: "textoTag",
                key: "textoTag",
                render: (text, record) => (
                    <Tag color={record.colorTag}>
                        {record.textoTag}
                    </Tag>
                ),
                width: "10%",
            },
            ...(!this.props.taxidermia ? [{
                title: "Cantidad",
                dataIndex: "cantidad",
                key: "cantidad",
                width: "10%",
            }] : []),
            {
                title: "Accion",
                key: "accion",
                render: (text, record) => (
                    <Space size="small">
                        {(this.props?.etapa?.etapaAnterior?.length > 0) ? this.props?.etapa?.etapaAnterior?.map((etapaAnt, index) => (
                            <ButtonItem
                                key={index}
                                type="primary"
                                disabled={this.state.loading}
                                naranja
                                style={{ marginLeft: 10 }}
                                onClick={() => this.moverLoteEtapa(record._id, etapaAnt._id)}
                            >{etapaAnt.nombre}</ButtonItem>
                        )) : null}
                        {(this.props?.etapa?.etapaSiguiente?.length > 0) ? this.props?.etapa?.etapaSiguiente?.map((etapaSig, index) => (
                            <ButtonItem
                                key={index}
                                type="primary"
                                verde
                                disabled={this.state.loading}
                                style={{ marginLeft: 10 }}
                                onClick={() => this.moverLoteEtapa(record._id, etapaSig._id)}
                            >{etapaSig.nombre}</ButtonItem>
                        )) : null}
                    </Space>
                ),
                width: "30%",
            },
        ];

        return (
            <>
                <ModalItem
                    title={"Actividades Etapa" + (this.props?.etapa?.nombre ? (" - " + this.props.etapa.nombre) : "") + (this.props?.etapa?.actividades?.length ? ` (${this.props?.etapa?.actividades?.length})` : "")}
                    visible={this.props.visible}
                    spinning={this.state.loading}
                    onCancel={() => this.cerrarListaEtapa(false)}
                    paddingTop
                    width={1600}
                >
                    <TableItem
                        loading={this.state.loading}
                        size="small"
                        dataSource={this.props?.etapa?.actividades || []}
                        columns={columns}
                        defaultPageSize={500}
                    />
                </ModalItem>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
        taxidermia: state.empresa.taxidermia,
    };
};

export default connect(mapStateToProps)(ModalListaEtapa);
